<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="computedDateFormatted"
        :label="label"
        :rules="rules"
        append-icon="mdi-calendar"
        filled
        readonly
        @click:append="menu = disabled ? true : false;alertDisabled(disabled)"
        v-on="on"
      />
    </template>
    <v-date-picker v-if="!disabled"
      color="secondary"
      v-model="date"
      @input="handleInput()"
      :min="min"
      :max="max"
      :locale="locale"
    ></v-date-picker>
  </v-menu>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'date-picker-field',
  props: ['label', 'value', 'rules', 'min', 'max', 'locale', 'disabled'],
  data: (vm) => ({
    date: vm.value,
    dateFormatted: vm.formatDate(new Date().toISOString().substring(0, 10)),
    menu: false
  }),
  methods: {
    ...mapActions('base', ['setSnackbar']),
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    handleInput () {
      this.menu = false
      this.$emit('input', this.date)
    },
    alertDisabled (disabled) {
      if (disabled) {
        this.showSnackbar('error', 'Não é possível editar datas após criação do microciclo.')
      }
    },
    showSnackbar (color, message) {
      this.setSnackbar({
        color,
        message,
        show: true
      })
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },
  watch: {
    value (newValue) {
      if (newValue === undefined) {
        this.date = ''
      } else {
        this.date = newValue
      }
    },
    date (val) {
      this.dateFormatted = this.formatDate(this.date)
    }
  }
}
</script>
